import { _ as _objectSpread2 } from './objectSpread2-04e3d2b4.esm.js';
import 'core-js/modules/es.array.concat.js';

var noopStorage = {
  getItem: function getItem(_key) {
    return '';
  },
  setItem: function setItem(_key, _value) {
    return null;
  },
  removeItem: function removeItem(_key) {
    return null;
  }
};
function createStorage(_ref) {
  var storage = _ref.storage,
    _ref$key = _ref.key,
    prefix = _ref$key === void 0 ? 'livepeer' : _ref$key;
  return _objectSpread2(_objectSpread2({}, storage), {}, {
    getItem: function getItem(key) {
      var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var value = storage.getItem("".concat(prefix, ".").concat(key));
      try {
        return value ? JSON.parse(value) : defaultState;
      } catch (error) {
        console.warn(error);
        return defaultState;
      }
    },
    setItem: function setItem(key, value) {
      if (value === null) {
        storage.removeItem("".concat(prefix, ".").concat(key));
      } else {
        try {
          storage.setItem("".concat(prefix, ".").concat(key), JSON.stringify(value));
        } catch (err) {
          console.error(err);
        }
      }
    },
    removeItem: function removeItem(key) {
      return storage.removeItem("".concat(prefix, ".").concat(key));
    }
  });
}

export { createStorage as c, noopStorage as n };
